import { render, staticRenderFns } from "./Invoice.Detail.vue?vue&type=template&id=94b5a832&"
import script from "./Invoice.Detail.vue?vue&type=script&lang=js&"
export * from "./Invoice.Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports